export default __webpack_public_path__ + "images/5cc711c105be735910eee8f2b2368f30.svg";